module.exports = __webpack_public_path__ + "static/media/increase-profit.db7c95e3.jpg";